import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var document, $;

@Component({
  selector: 'app-proofreader-progress',
  templateUrl: './proofreader-progress.component.html',
  styleUrls: ['./proofreader-progress.component.css']
})
export class ProofreaderProgressComponent implements OnInit {

    public activeUser         : any;
    public browserSub         : any;
    public shifts             : any = AppSettings.agentShifts;
    public despositionArray   : any = AppSettings.disposition;
    public documentTypeArray  : any = AppSettings.documentType;
    public siteAbbr           : any = AppSettings.siteAbbr;
    public empStatusClasses   : any = {
                                        'Employed'    : 'validBox',
                                        'WFH'         : 'validBox',
                                        'Probation'   : 'underReviewBox',
                                        'Internship'  : 'disabledBox',
                                        'Terminated'  : 'invalidBox',
                                        'Resigned'    : 'invalidBox'
                                      }
    public loading            : any = false;
    public paginatePage       : any;
    public leads              : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];
    public agentsSub          : any;
    public portalGlobals      : any;
    public agents             : any;
    public proofreaders       : any;
    public writers            : any;
    public qa                 : any;
    public loader             : any;


    @ViewChild(DataTableDirective)
    public dtElement    : DataTableDirective;
    public dtOptions    : DataTables.Settings = {};
    public dtTrigger    : any = new Subject();

    public searchParams          : any = { proof_reader: null, shift: null, date_from: '', date_to: '' };
    public fullRangeDate         : any;
    public selectedDesposition   : any;

    constructor(
      private authenticationService : AuthenticationService,
      private helperService         : HelperService,
      private agentsService         : Agents,
    ) {

      this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
        if (isBrowser) {
          // Get Agents
          this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
            if (agents) {
              this.portalGlobals = agents;
              this.agents        = agents.agents;
              this.proofreaders  = agents.proofreaders;
              this.writers       = agents.writers;
              this.qa            = agents.qa;
            }
          });

          // Get Active User
          this.activeUser = this.authenticationService.get_currentUserValue();

          // Init DataTable
          this.dtOptions = {
            paging: true,
            info: true,
            // ordering: false,
            pagingType: 'full_numbers',
            pageLength: 25,
            serverSide: true,
            processing: true,
            searching: false,
            'language': AppSettings.dataTableLang,
            "columnDefs": [
              { "orderable": false,                           "targets": 0 },
              { "orderable": true,                            "targets": 1 },
              { "orderable": false,                           "targets": 2 },
              { "orderable": false,                           "targets": 3 },
              { "orderable": false,                           "targets": 4 },
              { "orderable": true,                            "targets": 5 },
              { "orderable": true,                            "targets": 6 },
              { "orderable": true,                            "targets": 7 },
              { "orderable": true,                            "targets": 8 },

            ],
            "order": [[ 1, "ASC" ]],
            ajax: (dataTablesParameters: any, callback) => {
              // Show Loader
              this.loading = true;
              // console.log("dataTablesParameters", dataTablesParameters);

              let url  = AppSettings.API_ENDPOINT + 'proofreader/get-progress';

              let dtParams = {
                              proof_reader      : this.searchParams.proof_reader,
                              shift             : this.searchParams.shift,
                              date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                              date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                              start             : dataTablesParameters.start,
                              length            : dataTablesParameters.length,
                              order             : dataTablesParameters.order,
                              columns           : dataTablesParameters.columns
                            };

              // For Record Serial Numbers
              this.paginatePage = dataTablesParameters.start;

              // Empty Data
              this.leads = [];

              this.helperService.httpPostRequestsDecryp(url, dtParams)
                .then( resp => {
                    this.leads        = JSON.parse(resp);

                    // Set Default page len
                    this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                    // Hide Loader
                    this.loading = false;

                    callback({
                      recordsTotal: this.leads.total,
                      recordsFiltered: this.leads.total,
                      // recordsFiltered: resp['recordsFiltered'],
                      // recordsFiltered: 1000,
                      data: []
                    });

                    // // $(".paginate_button .current").css("color", "white");
                    // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                    $('div.dataTables_length select').addClass('dt-form-control');
                    $('div.dataTables_filter input').addClass('dt-form-control');
                })
                .catch(error => {
                    // Set loader false
                    this.loading = false;

                    // // Rerender DT in case of failure
                    // this.rerender();

                    console.log("error: ",error);
                });
            },
            columns: [
              // { data: 'multiDelete' },
              { data: 'id' },
              { data: 'name' },
              { data: 'designation' },
              { data: 'shift' },
              { data: 'employment_status' },
              { data: 'ordersInProgress' },
              { data: 'ordersCompleted' },
              { data: 'pages' },
              { data: 'averageRating' },
            ],
            // Use this attribute to enable the responsive extension
            responsive: false
          }
        }
      });
    }

    ngOnInit() {
    }

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();

      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
      }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate){
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }

      console.log("this.fullRangeDate", this.fullRangeDate);
      console.log("this.searchParams.date_from", this.searchParams.date_from);
      console.log("this.searchParams.date_to", this.searchParams.date_to);

      this.rerender();
    }

    updateDesposition(lead, index){
      let url = AppSettings.API_ENDPOINT + "admin/update-lead-status";
      let data = { id: lead.id, status: lead.status };
      this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined") {
          // this.leads =
          // this.rerender();
        }
      });
    }

    updateAgent(lead, index){
      console.log("lead", lead);

      let url = AppSettings.API_ENDPOINT + "admin/update-lead-agent";
      let data = { val: lead.agent_id, oid : lead.id };
      this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined" && resp.status == "OK") {
          Swal.fire('', resp.message , 'success');
        }
        if(typeof resp != "undefined" && resp.status == "ERROR") {
          Swal.fire('', resp.message , 'error');
        }
      });
    }

    showComments(lead,index){
      // this.loader = true;
      // console.log("this.lead", lead);

      this.loader = lead.id;

      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { l : lead.id, type: '' };
      this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined") {
          // console.log("resp", resp);
          this.comments = resp.data;
          this.agentComments = [];
          this.qaComments    = [];

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == "Leads-Comments") {
              this.agentComments.push(this.comments[i]);
            }
            else if(this.comments[i].type == "QA-Leads-Comments"){
              this.qaComments.push(this.comments[i]);
            }
            else{}
          }


          if (this.agentComments.length == 0 && this.qaComments.length == 0) {
            Swal.fire('No comments', "Agents and QA haven't added any comment yet." , 'info');
            this.loader = '';
          }
          else{
            if (typeof $ != "undefined") {
              this.loader = '';
              $("#comment_modal").modal("show");
            }
          }


        }

      });
    }

    agentSearch(id, agentArr) {
      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }

      if(id == '1733')
        return 'Support';

      return '';
    }

    designationSearch(id) {
      for (var i = 0; i < this.portalGlobals.designations.length; i++) {
        if (this.portalGlobals.designations[i].id === id) {
          return this.portalGlobals.designations[i].title;
        }
      }

      return '-';
    }

    clearFilters(){
      this.fullRangeDate = '';
      this.searchParams = { proof_reader: null, shift: null, date_from: '', date_to: '' };

      this.rerender();
    }

}
